<div #rangeSliderElement class="min-width">
  @if (disabled()) {
    <span id="umkreis_disabled_message">
      Der Umkreis kann erst ausgewählt werden, nachdem ein Ort eingegeben wurde. Bei einem
      eingegebenen Bundesland kann kein Umkreis ausgewählt werden.
    </span>
  } @else {
    <now-wbsuche-lib-range-slider
      [value]="suchumkreisAsId()"
      [range]="range"
      [labelFunction]="umkreisLabelFunction"
      [identifier]="'suchumkreis'"
      [label]="'Gewählter Umkreis'"
      (changed)="onSelectionChangedSlider($event)"
    ></now-wbsuche-lib-range-slider>
  }
</div>
